import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import $ from 'jquery'
// 页面title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

// http 请求拦截器
import httpRequest from './util/httpRequest.js'
Vue.prototype.$http = httpRequest;

// httpDowload 请求拦截器
import httpRequestDowload from './util/httpRequestDowload.js'
Vue.prototype.$httpDowload = httpRequestDowload;

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import Print from './util/print.js'
Vue.use(Print); 

//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
